<template>
  <div class="footer-action" @click="handleAction">
    <div class="promo-logo">
      <img src="@/assets/images/font-logo.svg" alt="" srcset="">
    </div>
    <div class="promo-text EN_6_Bold">{{ $t('common.openAppDetails') }}</div>
    <wxOpenApp v-if="isWeiXin" :appUrl="props.appData.open_app_url" :launch_app_id="props.appData.appId"></wxOpenApp>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { launchApp } from '@/utils/version';
import wxOpenApp from '@/components/wxOpenApp.vue';
import { useDeviceInfo } from '@/composables/useDeviceInfo';
const props = defineProps({
  appData: {
    type: Object,
    required: true,
    default: () => ({})
  }
});

const { isWechat } = useDeviceInfo();

const isWeiXin = computed(() => {
  return isWechat.value;
});

const handleAction = () => {
  console.log(props.appData.open_app_url, 'handleAction');
  launchApp(props.appData.open_app_url);
}

</script>

<style scoped lang="scss">
.footer-action {
  display: flex;
  padding: var(--padding-11) 0px var(--padding-4) 0px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--gap-6);
  align-self: stretch;
}

.promo-logo {
  height: 20px;

  img {
    height: 100%;
  }
}

.promo-text {
  color: var(--on-container-text-secondary);
}
</style> 